import React from 'react';
import { inject, observer } from 'mobx-react';
import type { AppStore } from '@stores/app/store';
import type { SiteAction } from '@stores/site/action';
import type { UserAction } from '@stores/user/action';
import H5Header from './h5';
import PCHeader from './pc';
import { withRouter, RouteComponentProps } from 'react-router-dom';
// import { getUrlParams } from '@utils/getUrlParams';
import { getCookie } from '@utils/cookie';
import { readSearchKeywords } from '@server';

const API_BASE_URL = process.env.REACT_APP_API_BASE || '';

interface HeaderProps {
    app?: AppStore;
    site?: SiteAction;
    user?: UserAction;
    topic?: any;
    navClick?: any;
    showDownloadApp?: boolean;
    closeAppDownloadEnter?: any;
    handleSetState?: Function;
    isShowHeader?: any
}

interface HeaderState {
    navList: any[];
    navCurrentIndex: any;
    prevFocusId?: string;  // 保存上一次的 focusId
    searchValue: any
    searchKeywords: string[];
}

type HeaderAllProps = HeaderProps & RouteComponentProps;

@inject('app', 'site', 'user', 'topic')
@observer
class Header extends React.Component<HeaderAllProps, HeaderState> {
    private disposed = false;
    constructor(props: HeaderAllProps) {
        super(props);
        this.state = {
            // 保持导航数据结构，即使未登录不请求关注话题，固定导航也能正常显示。
            navList: [[], [], []],
            navCurrentIndex: 'home',
            prevFocusId: undefined,
            searchValue: '',
            searchKeywords: [],
        };
    }

    // 仅依据已有登录态判断，不触发登录跳转，避免未登录时请求关注话题。
    isUserLoggedIn = () => Boolean(
        this.props.user?.isLoggedIn
        || this.props.user?.userInfo
        || this.props.user?.token
        || getCookie('user_code')
    );

    async componentDidMount() {
        this.disposed = false;
        this.loadSearchKeywords();
        console.log('Header mounted');
        const { topic, user } = this.props;
        // if (user) {
        //     user.fetchUserInfo({ code: user?.userInfo?.code });
        // }
        // const routerParams = new URLSearchParams(this.props.location.search);
        // console.log(routerParams,'浏览器上的参数', getUrlParams());
        // 关注话题属于用户私有数据，未登录时不调用接口。
        if (topic && this.isUserLoggedIn()) {
            try {
                const res = await topic.getTopicsFollows();
                // console.log('获取到导航数据:', res);

                this.setState({
                    navList: res
                }, () => {
                    // 初始化时设置导航索引
                    this.updateNavIndexByFocusId();
                });
            } catch (error) {
                // console.error('获取导航数据失败:', error);
            }
        }
    }

    componentWillUnmount() {
        this.disposed = true;
    }

    loadSearchKeywords = async () => {
        try {
            const response = await readSearchKeywords();
            if (this.disposed || response.code !== 0) return;
            const list = response.data?.search_keyword;
            const keywords: string[] = Array.isArray(list)
                ? list.map(item => typeof item?.keyword === 'string' ? item.keyword.trim() : '').filter(Boolean)
                : [];
            this.setState({ searchKeywords: Array.from(new Set(keywords)).slice(0, 6) });
        } catch {
            // 推荐词不可用时保留普通搜索。
        }
    };

    componentDidUpdate(prevProps: HeaderAllProps) {
        const { location, topic } = this.props;
        const { prevFocusId, navList } = this.state;

        // 从 URL 获取当前的 focusId
        const urlParams = new URLSearchParams(location.search);
        const currentUrlFocusId = urlParams.get('focusId');

        const pathTopicId = this.getTopicIdFromPath();

        const currentPropFocusId = topic?.followTopicFocusId;

        const currentFocusId = currentUrlFocusId || pathTopicId || currentPropFocusId;

        if (currentFocusId && currentFocusId !== prevFocusId) {

            this.setState({
                prevFocusId: currentFocusId
            }, () => {
                this.updateNavIndexByFocusId();
            });
        }
        // console.log(currentFocusId, prevFocusId, '焦点id')

        if (!currentFocusId && prevFocusId) {
            this.setState({
                prevFocusId: undefined,
                navCurrentIndex: ''
            });
        }
    }

    private getTopicIdFromPath = (): string | null => {
        const { location } = this.props;
        const pathname = location.pathname;
        const match = pathname.match(/\/topicDetail\/(\d+)/);
        return match ? match[1] : null;
    }

    // 获取当前平台（h5 或 pc）
    private getPlatform = (): string => {
        return this.props.app?.platform || 'h5';
    }
    private updateNavIndexByFocusId = () => {
        const { navList, navCurrentIndex } = this.state;
        const { topic, location } = this.props;

        const urlParams = new URLSearchParams(location.search);
        const urlFocusId = urlParams.get('focusId');

        const pathTopicId = this.getTopicIdFromPath();

        const propFocusId = topic?.followTopicFocusId;

        const focusId = urlFocusId || pathTopicId || propFocusId;

        if (!focusId || !navList?.[0]?.length) {
            return;
        }


        for (let index = 0; index < navList[0].length; index++) {
            const item = navList[0][index];
            if (String(item?.topicId) === String(focusId)) {
                if (index !== navCurrentIndex) {
                    this.setState({
                        navCurrentIndex: index
                    });
                }
                return;
            }
        }

    }

    // 导航点击处理
    navClick = (item: any, type: string, val: number) => {
        console.log(type, '类型')
        const { topic, history } = this.props;


        this.setState({
            navCurrentIndex: val,
            prevFocusId: undefined  // 用户手动点击，清除记录的 focusId
        });
        // 2. 清除 store 中的 focusId
        if (topic) {
            topic.setFollowTopicFocusId('');
        }

        // 3. 执行跳转
        if (type === 'home') {
            history.push('/');
        } else if (type === 'activity') {
            history.push('/activityList');
        } else if (type === 'goods') {
            history.push('/goodsDetail');
        } else if(type === 'feedback') {
            history.push(`/feedbackList`);
        } else {
            history.push(`/topicDetail/${item.topicId}?type=0`);
        }
    }
    // 关闭h5顶部的下载app入口
    closeAppDownloadEnterClick = () => {
        const { site } = this.props;
        site?.setAppDownloadShowStatus(false);
        // this.props.handleSetState?.({
        //     showDownloadApp: false
        // });
    }
    // 登录
    loginClick = () => {
        const platform = this.getPlatform();  // 获取当前平台
        let OAUTH_URL = `${API_BASE_URL}/api/v3/users/vivo/oauth?platform=${platform}`;
        // 获取页面路径上的inviteCode参数
        const urlParams = new URLSearchParams(window.location.search);
        const inviteCode = urlParams.get('inviteCode');
        
        // 如果存在inviteCode，拼接到链接后面
        if (inviteCode) {
            OAUTH_URL += `&inviteCode=${encodeURIComponent(inviteCode)}`;
        }
        window.location.href = OAUTH_URL;
    }

    // 确认搜索
    searchConfirm = (keyword?: string) => {
        const { history } = this.props;
        const { searchValue } = this.state;
        const value = (keyword ?? searchValue).trim();
        if (!value) return;
        this.setState({ searchValue: value });
        const encodedKeyword = encodeURIComponent(value);
        const url = `/search?keyword=${encodedKeyword}`;
        // 跳转到搜索页，携带搜索参数
        history.push(url);
    }

    // 改为类方法
    handleSetState = (data: any) => {
        this.setState({ ...data });
    };

    render() {
        
        const { site, app, user, showDownloadApp, isShowHeader, ...props } = this.props;
        const { navList, navCurrentIndex, searchValue, searchKeywords } = this.state;
        const platform = app?.platform || 'h5';

        const userInfo = user?.userInfo || {};
        const avatar = userInfo?.avatarUrl || '';
        const nickname = userInfo?.nickname || '';

        const { handleSetState: propsHandleSetState, ...otherProps } = props;
    
        const headerProps = {
            ...otherProps,  // 不包含 handleSetState
            avatar,
            nickname,
            userInfo
        };

        if (platform === 'pc') {
            return (
                <PCHeader
                    nav={navList}
                    loginClick={this.loginClick}
                    navClick={this.navClick}
                    navCurrentIndex={navCurrentIndex}
                    searchConfirm={this.searchConfirm}
                    searchValue={searchValue}
                    searchKeywords={searchKeywords}
                    handleSetState={this.handleSetState}
                    {...headerProps}
                />
            );
        }

        return (
            <H5Header
                loginClick={this.loginClick}
                showDownloadApp={showDownloadApp}
                navClick={this.navClick}
                navCurrentIndex={navCurrentIndex}
                closeAppDownloadEnter={this.closeAppDownloadEnterClick}
                nav={navList}
                isShowHeader={isShowHeader}
                searchConfirm={this.searchConfirm}
                searchValue={searchValue}
                searchKeywords={searchKeywords}
                handleSetState={(data, rep) => this.setState({ ...data })}
                {...headerProps}
            />
        );
    }
}

export default withRouter(Header);
